export const AUTHORIZE = "AUTHORIZE";
export const AUTH_ERROR = "AUTH_ERROR";
export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const CHANGE_PASSWORD = "CHANGE_PASSWORD";

export const GO_KINTAI = "GO_KINTAI";

export const GET_USER = "GET_USER";
export const CREATE_USER = "CREATE_USER";
export const EDIT_USER = "EDIT_USER";
export const SHOW_USER = "SHOW_USER";
export const DELETE_USER = "DELETE_USER";
export const GENERAL_GET_USER = "GENERAL_GET_USER";

export const GET_COMPANY = "GET_COMPANY";
export const SHOW_COMPANY = "SHOW_COMPANY";

export const GET_DEPARTMENT = "GET_DEPARTMENT";
export const SHOW_DEPARTMENT = "SHOW_DEPARTMENT";
export const CREATE_DEPARTMENT = "CREATE_DEPARTMENT";
export const EDIT_DEPARTMENT = "EDIT_DEPARTMENT";
export const DELETE_DEPARTMENT = "DELETE_DEPARTMENT";

export const GET_POSITION = "GET_POSITION";
export const SHOW_POSITION = "SHOW_POSITION";
export const CREATE_POSITION = "CREATE_POSITION";
export const EDIT_POSITION = "EDIT_POSITION";
export const DELETE_POSITION = "DELETE_POSITION";

export const GET_CAR = "GET_CAR";
export const SHOW_CAR = "SHOW_CAR";
export const CREATE_CAR = "CREATE_CAR";
export const EDIT_CAR = "EDIT_CAR";
export const DELETE_CAR = "DELETE_CAR";

export const GET_PHRASE = "GET_PHRASE";
export const SHOW_PHRASE = "SHOW_PHRASE";
export const CREATE_PHRASE = "CREATE_PHRASE";
export const EDIT_PHRASE = "EDIT_PHRASE";
export const DELETE_PHRASE = "DELETE_PHRASE";

export const GET_HOLIDAY = "GET_HOLIDAY";
export const SHOW_HOLIDAY = "SHOW_HOLIDAY";
export const CREATE_HOLIDAY = "CREATE_HOLIDAY";
export const EDIT_HOLIDAY = "EDIT_HOLIDAY";
export const DELETE_HOLIDAY = "DELETE_HOLIDAY";

export const GET_RANK_HISTORY = "GET_RANK_HISTORY";
export const SHOW_RANK_HISTORY = "SHOW_RANK_HISTORY";
export const CREATE_RANK_HISTORY = "CREATE_RANK_HISTORY";
export const EDIT_RANK_HISTORY = "EDIT_RANK_HISTORY";
export const DELETE_RANK_HISTORY = "DELETE_RANK_HISTORY";

export const GET_ACCIDENT_HISTORY = "GET_ACCIDENT_HISTORY";
export const SHOW_ACCIDENT_HISTORY = "SHOW_ACCIDENT_HISTORY";
export const CREATE_ACCIDENT_HISTORY = "CREATE_ACCIDENT_HISTORY";
export const EDIT_ACCIDENT_HISTORY = "EDIT_ACCIDENT_HISTORY";
export const DELETE_ACCIDENT_HISTORY = "DELETE_ACCIDENT_HISTORY";

export const GET_DEPARTMENT_HISTORY = "GET_DEPARTMENT_HISTORY";
export const CREATE_DEPARTMENT_HISTORY = "CREATE_DEPARTMENT_HISTORY";
export const DELETE_DEPARTMENT_HISTORY = "DELETE_DEPARTMENT_HISTORY";

export const GET_POSITION_HISTORY = "GET_POSITION_HISTORY";
export const CREATE_POSITION_HISTORY = "CREATE_POSITION_HISTORY";
export const DELETE_POSITION_HISTORY = "DELETE_POSITION_HISTORY";

export const FORCE_UPDATE_POSITION_HISTORY = "FORCE_UPDATE_POSITION_HISTORY";
export const FORCE_UPDATE_DEPARTMENT_HISTORY =
  "FORCE_UPDATE_DEPARTMENT_HISTORY";

export const GET_COMPANY_NOTICE = "GET_COMPANY_NOTICE";
export const SHOW_COMPANY_NOTICE = "SHOW_COMPANY_NOTICE";
export const CREATE_COMPANY_NOTICE = "CREATE_COMPANY_NOTICE";
export const EDIT_COMPANY_NOTICE = "EDIT_COMPANY_NOTICE";
export const DELETE_COMPANY_NOTICE = "DELETE_COMPANY_NOTICE";

export const GET_APPROVAL = "GET_APPROVAL";
export const GET_APPROVAL_BY_DEPARTMENT_TYPE =
  "GET_APPROVAL_BY_DEPARTMENT_TYPE";
export const CREATE_OR_EDIT_APPROVAL = "CREATE_OR_EDIT_APPROVAL";

export const GET_EXIST_APPROVAL = "GET_EXIST_APPROVAL";

export const GET_ATTENDANCE_LIST = "GET_ATTENDANCE_LIST";
export const SHOW_ATTENDANCE_DETAIL = "SHOW_ATTENDANCE_DETAIL";
export const SHOW_ATTENDANCE_USER_DETAIL = "SHOW_ATTENDANCE_USER_DETAIL";
export const GET_ATTENDANCE_DATE_DETAIL = "GET_ATTENDANCE_DATE_DETAIL";
export const PDF_DAILY_REPORT = "PDF_DAILY_REPORT";
export const ADMIN_ATTENDANCE_UPDATE = "ADMIN_ATTENDANCE_UPDATE";
export const APPROVAL_ATTENDANCE_UPDATE = "APPROVAL_ATTENDANCE_UPDATE";
export const UPDATE_ALL_APPROVALED = "UPDATE_ALL_APPROVALED";
export const CHECK_LEAVE_REASON = "CHECK_LEAVE_REASON";
export const IMPORT_CSV_PAID_LEAVE = "IMPORT_CSV_PAID_LEAVE";

export const GET_SITE = "GET_SITE";
export const GET_SITE_PAGENATION = "GET_SITE_PAGENATION";
export const GET_SITE_DETAIL = "GET_SITE_DETAIL";
export const SAVE_SITE = "SAVE_SITE";
export const UPDATE_CONST_DONE = "UPDATE_CONST_DONE";
export const DELETE_SITE = "DELETE_SITE";
export const IMPORT_CSV = "IMPORT_CSV";

export const GET_APPROVAL_ATTENDANCE = "GET_APPROVAL_ATTENDANCE";
export const GET_APPROVAL_LEAVE = "GET_APPROVAL_LEAVE";
export const GET_APPROVAL_OVERTIME = "GET_APPROVAL_OVERTIME";

export const FORCE_APPROVAL_REJECTION = "FORCE_APPROVAL_REJECTION";
export const SET_APPROVAL_ATTENDANCE = "SET_APPROVAL_ATTENDANCE";
export const SET_APPROVAL_ATTENDANCE_ALL = "SET_APPROVAL_ATTENDANCE_ALL";
export const SET_APPROVAL_LEAVE = "SET_APPROVAL_LEAVE";
export const SET_APPROVAL_OVERTIME = "SET_APPROVAL_OVERTIME";

export const GET_NOTICE = "GET_NOTICE";

export const GET_SITE_CSV = "GET_SITE_CSV";
export const GET_TKC_CSV = "GET_TKC_CSV";
export const GET_ATTENDANCE_CSV = "GET_ATTENDANCE_CSV";
export const GET_ATTENDANCE_CSV_SUMMARY = "GET_ATTENDANCE_CSV_SUMMARY";
export const GET_COST_CSV = "GET_COST_CSV";

export const GET_LATEST_DEPARTMENT_HISTORY = "GET_LATEST_DEPARTMENT_HISTORY";
export const GET_LATEST_POSITION_HISTORY = "GET_LATEST_POSITION_HISTORY";
